/**
 * Makes links in rich text open in a new tab, so that a visitor following a link keeps the profile open. The rich
 * text editor stores links with target="_self", which is why this is done when rendering.
 */
export function openLinksInNewTab(html?: string): string | undefined {
  if (!html || !html.includes("<a") || typeof document === "undefined") return html;
  const template = document.createElement("template");
  template.innerHTML = html;
  template.content.querySelectorAll("a[href]").forEach((link) => {
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noopener noreferrer");
  });
  return template.innerHTML;
}
